//const api: string|undefined= process.env.REACT_APP_API;

import Api from "../../utils/api";
import { API_URLS } from "../../utils/api.urls";

export const fetchCartCount = async (): Promise<any> => {
  const data = await Api.get(API_URLS.GET_CART_COUNT, []);
  return data;
};
